import style from './DropContent.module.scss'

interface IProps {
    list: { title: string; value: string | null; locator: string }[]
    filterKey: string
    onGetFilteredList: (filterKey: string, opt: string | null) => void
}

export const DropContent = (props: IProps) => {
    const { list, filterKey, onGetFilteredList } = props
    return (
        <div className={style.container}>
            {list.map((opt) => {
                const onFilterDoctors = () => {
                    onGetFilteredList(filterKey, opt.value)
                }
                return (
                    <div key={opt.title} onClick={onFilterDoctors} data-locator={opt.locator}>
                        {opt.title}
                    </div>
                )
            })}
        </div>
    )
}
